module.exports = __webpack_public_path__ + "img/aixin.8b763073.png";